import axios from 'axios';

// Align with global API base used across the app
const API_URL = process.env.REACT_APP_API_URL || 'https://api.badeil.com/api/v1';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Disable credentials to avoid CORS issues for public auth endpoints
  withCredentials: false,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Update user profile
export const updateProfile = async (profileData) => {
  try {
    const response = await api.put('/auth/updatedetails', profileData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Request password reset (send verification code)
export const requestPasswordReset = async (email) => {
  try {
    const response = await api.post('/auth/forgotpassword', { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Verify reset code
export const verifyResetCode = async (email, code) => {
  try {
    const response = await api.post('/auth/verify-reset-code', { email, code });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Reset password with verified code
export const resetPassword = async (email, code, newPassword) => {
  try {
    const response = await api.post('/auth/reset-password', {
      email,
      resetToken: code,
      newPassword
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Change password with current password
export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await api.put('/auth/updatepassword', {
      currentPassword,
      newPassword
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export default {
  updateProfile,
  requestPasswordReset,
  verifyResetCode,
  resetPassword,
  changePassword
};
